import { useMutation } from 'react-query';
import axios from 'axios';

import { useAuth } from '@/modules/Auth/hooks/useAuth';
import { AwsConfigApiGateway } from '@/utils/config/api';

async function deleteWorkspaceById(workspaceId: string, token: string | undefined) {
  const response = await axios.delete<string>(`${AwsConfigApiGateway.pooledTenantApiUrl}/workspaces/${workspaceId}`, {
    headers: {
      'x-api-key': AwsConfigApiGateway.pooledTenantApiKey,
      Authorization: 'Bearer ' + token,
    },
  });
  return response.data;
}

export function useDeleteWorkspaceById() {
  const { user } = useAuth();
  return useMutation<string, Error, string>((data) =>
    deleteWorkspaceById(data, user?.signInUserSession.idToken.jwtToken),
  );
}
